import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AccountModel} from "../../../../../domain/models/account.model";
import {Icons} from "../../../../../domain/enums/icons-enums";
import {RouterModule} from "@angular/router";
import {IconDetailComponent} from "../../../../../common/icon-detail/icon-detail.component";
import {ContactInfoCardComponent} from "../../../../../common/contact-info-card/contact-info-card.component";
import {AddressInfoCardComponent} from "../../../../../common/address-info-card/address-info-card.component";
import {MatDividerModule} from "@angular/material/divider";
import {MatTabsModule} from "@angular/material/tabs";
import {ProfileTabComponent} from "../components/profile-tab/profile-tab.component";
import {BillingTabComponent} from "../components/billing-tab/billing-tab.component";
import {PropertiesTabComponent} from "../components/properties-tab/properties-tab.component";
import {AccountReceiptsTabComponent} from "../components/account-receipts-tab/account-receipts-tab.component";
import {AccountBankingTabComponent} from "../components/account-banking-tab/account-banking-tab.component";
import {AccountNotesTabComponent} from "../components/account-notes-tab/account-notes-tab.component";
import {AccountAttachmentsTabComponent} from "../components/account-attachments-tab/account-attachments-tab.component";
import {AccountHistoryTabComponent} from "../components/account-history-tab/account-history-tab.component";
import {AccountReturnsTabComponent} from "../components/account-returns-tab/account-returns-tab.component";
import {MatButton} from "@angular/material/button";
import {MatCard} from "@angular/material/card";
import {MatIcon} from "@angular/material/icon";
import {RentalPropertyComponent} from "../../../../property/rental-property/rental-property.component";
import {CommonModule} from "@angular/common";
import {CustomerFormComponent} from "../components/customer-form-component";
import {CustomerResumeBarComponent} from "../../../../../common/customer-resume-bar/customer-resume-bar.component";

@Component({
  selector: 'app-account-detail-individual-owner',
  standalone: true,
  imports: [
    CustomerResumeBarComponent,
    IconDetailComponent,
    ContactInfoCardComponent,
    AddressInfoCardComponent,
    MatDividerModule,
    MatTabsModule,
    ProfileTabComponent,
    BillingTabComponent,
    PropertiesTabComponent,
    AccountReceiptsTabComponent,
    AccountBankingTabComponent,
    AccountNotesTabComponent,
    AccountAttachmentsTabComponent,
    AccountHistoryTabComponent,
    AccountReturnsTabComponent,
    RouterModule,
    MatButton,
    MatCard,
    MatIcon,
    RentalPropertyComponent,
    CommonModule,
  ],
  templateUrl: './account-detail-individual-owner.component.html',
  styleUrl: './account-detail-individual-owner.component.css'
})
export class AccountDetailIndividualOwnerComponent implements CustomerFormComponent {
  @Input() account!: AccountModel;
  /** Set from the URL so returning to this account lands on the tab it was left on. */
  @Input() selectedIndex = 0;
  @Output() selectedTab = new EventEmitter<number>();
  @ViewChild(ProfileTabComponent) profile!: ProfileTabComponent;
  icons = Icons;

  getUpdatedAccount(): AccountModel {
    return this.profile.getUpdatedAccount();
  }

  isFormValid(): boolean {
    return this.profile.isFormValid();
  }

  raiseFormValidations(): void {
    this.profile.raiseFormValidations();
  }
}
